import React from 'react';
//todo use compiled when @atlaskit/image supports it
//the image is moved to a separate file due to
//https://atlassian.slack.com/archives/CFJ9DU39U/p1691750071893489
import css from '@emotion/css';

import Image from '@atlaskit/image';

const modalImage = css`
	position: absolute;
	width: 100%;
	height: 100% !important;
	object-fit: cover;
	object-position: center;
`;

type ModalImageProps = {
	src: string;
	srcDark: string;
};

export function ModalImage({ src, srcDark }: ModalImageProps) {
	return <Image src={src} srcDark={srcDark} css={modalImage} />;
}
